import LanguageMenuComponent from './LanguageMenuComponent';

const LanguageMenu = LanguageMenuComponent;

export default LanguageMenu;
